import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    numeric,
    helpers,
} from '@vuelidate/validators'

const atLeastOneSelected = (value) => value.length > 0

const minOrEqualToPlanned = (value, siblings) => {
    if (value === null || value === '' || value === undefined) return true
    return Number(value) >= Number(siblings.planned_usage_per_a)
}

export default {
    name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(100),
    },
    customization_degree: {
        required,
    },
    model_year: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4),
    },
    is_stationary: {
        required,
    },
    currency_code: {
        required,
    },
    value: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(9999999999),
    },
    refurbishment: {
        minValue: minValue(0),
        maxValue: maxValue(9999999999),
        required,
    },
    planned_usage_per_a: {
        required,
        minValue: minValue(1),
    },
    maximum_usage_per_a: {
        minValue: minValue(1),
        minOrEqualToPlanned: helpers.withMessage(
            '§eq_type.maximum_usage_per_a_has_to_be_greater_than_or_equal_to_planned_usage_per_a',
            minOrEqualToPlanned
        ),
    },
    billing_units: {
        required,
        atLeastOneSelected,
    },
}
